//angular modules
//DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//soco modules
import { SocoAlertModule } from '@soco/alert';
import { SocoFormsModule } from '@soco/forms';
import { SocoModalModule } from '@soco/modal';
import { SocoUIThemeModule } from '@soco/ui-theme';

//app modules
import { CoreModule } from '../core/core.module';

//components
//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent

import { RescheduleComponent } from './reschedule.component';
import { RescheduleRoutes } from './reschedule.routing';
import { AgmCoreModule } from '@agm/core';
import { AvailabilityModule } from '../shared/components/availability/availability-selection.module';
import { CovidQuestionnaireModule } from '../shared/components/covidquestionnaire/covid-questionnaire.module';
import { AppointmentConfirmationModule } from '../shared/components/appointmentconfirmation/appointment-confirmation.module';
import { BnNgIdleService } from 'bn-ng-idle';
//import { AppBaseModule } from '../shared/components/base/app-base.module';


@NgModule({
    imports: [
        //angular modules
        CommonModule,
        RouterModule.forChild(RescheduleRoutes),
        FormsModule,
        ReactiveFormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBcLYsBQdhvhsdRoDKPzt3STCHmIXsXCNU'
          }),

        //soco modules        
        SocoUIThemeModule,
        SocoAlertModule,
        SocoFormsModule,
        SocoModalModule,

        //app modules
        CoreModule,
        AvailabilityModule,
        CovidQuestionnaireModule,
        AppointmentConfirmationModule
        //AppBaseModule
        
    ],
    exports: [RescheduleComponent],
    declarations: [        
        RescheduleComponent
    ],
    providers: [BnNgIdleService]
})

export class RescheduleModule { }

